import AnimatedScreenMessage from '@rhg/components/animated-screen-message';
import PageTitle from '@rhg/components/page-title';
import commonMessages from '@rhg/lang/messages/common';
import { useIntl } from 'react-intl';

const NotFoundPage = () => {
    const { formatMessage } = useIntl();
    return (
        <>
            <PageTitle
                title={formatMessage(
                    commonMessages['common.error.not_found.page_header']
                )}
            />
            <AnimatedScreenMessage
                title={formatMessage(
                    commonMessages['common.error.not_found.page_header']
                )}
                subtitle={formatMessage(
                    commonMessages['common.error.not_found.page_body']
                )}
                displayLogo
            />
        </>
    );
};

export default NotFoundPage;
